/**
 * Checks if a value is part of the given enum object.
 * @param enumObject object representing the enum
 * @param value value to check
 * @returns true if the value is part of the enum, false otherwise
 */
export function isEnumValue<T extends Record<string, string>>(
  enumObject: T,
  value: string,
): value is T[keyof T] {
  return Object.values(enumObject).includes(value);
}
